import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLayoutLeftLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 12 12",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.33333 0C0.596953 0 0 0.596953 0 1.33333V10.6667C0 11.4031 0.596953 12 1.33333 12H10.6667C11.4031 12 12 11.4031 12 10.6667V1.33333C12 0.596953 11.4031 0 10.6667 0H1.33333ZM4.66667 1.33333H10.6667V10.6667H4.66667V1.33333ZM3.33333 1.33333H1.33333V10.6667H3.33333V1.33333Z",
		fill: "currentColor"
	})
});
export default SvgLayoutLeftLine;
